<template>
  <div class="home bar-content">
    <Nav :show="true" :auto-search-top="autoSearchTop" @goFormMap="goFormBox" @headerSearchHide="updateSearchZipcode" />
    <div class="home-content">
      <div class="center banner">
        <div class="banner-search">
          <p class="title">
            Moving Kite, Moving Light
          </p>
          <p class="desc">
            <span class="span-first"
              >Store your boxes for<img src="../../assets/imgs/money.png" style="width:148px; height:40px"
            /></span>
            <span class="span-second">Pack and ship, we will take care of the rest.</span>
          </p>
          <div>
            <div class="search-box">
              <Search ref="search" @calculateZipcode="calculateZipcode" @change="calculateZipcodeChange" />
              <p class="zip-errmsg">{{ zipcodeError }}</p>
            </div>
            <!--            v-if="$store.state.send.isChange"-->
            <div v-if="continueCardShow" class="continue-card">
              <span @click="doContinue"> Continue to moving from {{ previousZipcode }} > </span>
              <img src="../../assets/imgs/home-close.png" @click="doCloseCard" />
            </div>
          </div>
        </div>
        <img class="banner-img" src="../../assets/imgs/home-1.png" />
      </div>

      <!--      表单收集页-->
      <div ref="homeFormRef" class="center">
        <PriceForm
          ref="priceFormRef"
          :change="$route.query.change ? $route.query.change : 0"
          @getPriceSuccess="showPrice"
        ></PriceForm>
      </div>

      <div class="works-bg">
        <div class="center works">
          <TitleBar
            class="center-text works-title"
            title="Here's how it works"
            desc="Door-to-Door FedEx shipping anywhere in the US"
          />
          <ul class="works-list">
            <li v-for="item in works" :key="item.title" class="work-item">
              <WorkItem
                :title="item.title"
                :desc="item.desc"
                :count="item.count"
                :bcolor="item.bcolor"
                :icon="item.icon"
              />
            </li>
          </ul>
        </div>
      </div>

      <div class="center what">
        <p class="title">Hassle-Free Moving</p>
        <div class="what-content">
          <ul class="what-list">
            <li v-for="item in whats" :key="item.title">
              <p class="what-title">{{ item.title }}</p>
              <p class="what-desc">{{ item.desc }}</p>
            </li>
          </ul>
          <div class="img-box">
            <img src="../../assets/imgs/home-3.png" />
          </div>
        </div>
      </div>

      <div class=" center delight ">
        <img src="../../assets/imgs/home-4.png" class="delight-img-box" />
        <div class="delight-right">
          <div>
            <p class="delight-title">A Light Moving For You</p>
            <p class="delight-desc">Affordable, Convenient, Fexible</p>
          </div>
          <div class="delight-right-content">
            <ul class="delight-right-list">
              <li v-for="item in delights" :key="item.title">
                <p class="delight-right-title">{{ item.title }}</p>
                <p class="delight-right-desc">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Cookie v-if="!cookiePrivacy" />
  </div>
</template>
<script>
import Nav from '../../components/comm/Nav';
import Footer from '../../components/comm/Footer';
import Search from '../../components/comm/Search';
import TitleBar from '../../components/home/TitleBar';
import PriceForm from '../../components/home/PriceForm';
import WorkItem from '../../components/home/WorkItem';
import Cookie from '../../components/comm/Cookie';
import config from './config.js';
import { mapState } from 'vuex';

export default {
  components: {
    Nav,
    Footer,
    Search,
    TitleBar,
    WorkItem,
    Cookie,
    PriceForm,
  },
  data() {
    return {
      autoSearchTop: 320,
      works: config.works,
      whats: config.whats,
      delights: config.delights,
      zipcodeError: '',
      previousZipcode: '',
      continueCardShow: false,
    };
  },
  mounted() {
    let cacheDataObj = this.$store.state.home.formComponentData;
    this.previousZipcode = cacheDataObj.zipcodeInput;
    if (this.$route.query.change) {
      this.showPrice(cacheDataObj.answerType);
      this.continueCardShow = false;
    }
  },
  beforeRouteEnter(to, form, next) {
    next(vm => {
      let change = vm.$store.state.home.setCache;
      let cacheDataObj = vm.$store.state.home.formComponentData;
      if (change && cacheDataObj.zipcodeInput) {
        vm.continueCardShow = true;
        vm.previousZipcode = cacheDataObj.zipcodeInput;
      } else {
        vm.continueCardShow = false;
      }
    });
  },
  methods: {
    classIndex(index) {
      return `img${index + 1}`;
    },
    goFormBox(zipcode) {
      if (this.checkZipCode(zipcode)) {
        this.$refs.priceFormRef.formShow = true;
        this.continueCardShow = false;
        //下面450表示在纵轴上要滚动的距离，越大，显示的范围越往下。如果要更改改这个值；
        //这里只是点击header上的按钮才生效
        window.scroll(0, 400);
      }
    },
    calculateZipcode(zipcode) {
      this._checked = true;
      //点击页面内的按钮
      if (this.checkZipCode(zipcode)) {
        this.$refs.priceFormRef.formShow = true;
        this.$refs.priceFormRef.getFocus();
        this.continueCardShow = false;
        const targetElement = this.$refs.homeFormRef;
        window.scrollTo({ top: targetElement.offsetTop - 90, behavior: 'smooth' });
      }
    },
    showPrice(type) {
      if (type === 'false') {
        window.scroll({ top: 910, left: 0, behavior: 'smooth' });
      } else {
        window.scroll({ top: 935, left: 0, behavior: 'smooth' });
      }
    },
    updateSearchZipcode() {
      this.$refs.search.zipCode = this.$store.state.home.zipcode;
    },
    calculateZipcodeChange(zipcode) {
      if (zipcode !== this.$store.state.home.zipcode) {
        this.$refs.priceFormRef.formShow = false;
        this.$refs.priceFormRef.secondShow = false;
        this.$refs.priceFormRef.searchError = '';
      }
      this.zipcodeError = '';
      // if (this._checked) {
      //   this.checkZipCode(zipcode);
      // }
    },
    checkZipCode(zipcode) {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      this.zipcodeError = '';
      if (zipreg.test(zipcode)) {
        return true;
      } else {
        this.zipcodeError = 'Please enter a correct ZIP';
        this.$refs['search'].setError();
        return false;
      }
    },
    goCalculate() {
      this.$router.push({
        name: 'calculate',
      });
    },
    doContinue() {
      this.$refs.priceFormRef.continueForm();
      let cacheDataObj = this.$store.state.home.formComponentData;
      this.$refs.search.zipCode = cacheDataObj.zipcodeInput;
      this.$refs.search.change();
      window.scroll(0, 400);
      this.continueCardShow = false;
    },
    doCloseCard() {
      this.continueCardShow = false;
      this.$store.commit('home/updateChangeValue', false);
      this.$store.commit('home/updateSetCacheValue', false);
    },
  },
  computed: {
    ...mapState({
      cookiePrivacy: state => state.app.cookiePrivacy,
    }),
    ...mapState('home', ['zipcode']),
  },
};
</script>
<style lang="less">
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.home-content {
  background: #ffffff;
  .banner {
    //height: 400px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .banner-search {
      //width: 623px;
      padding-right: 150px;
      .title {
        .font-regular;
        font-size: 22px;
        font-weight: bold;
        color: @app-black-color;
        line-height: 40px;
      }
      .desc {
        .span-first {
          .font-regular;
          display: flex;
          align-items: center;
          font-size: 20px;
          color: @app-black-color;
          font-weight: bold;
        }
        .span-second {
          .font-regular;
          font-size: 18px;
          color: @app-body-color;
        }
      }
      .search-box {
        margin-top: 60px;
        .zip-errmsg {
          .font-regular;
          color: @app-error-color;
          font-size: 14px;
          padding-top: 10px;
        }
      }
      .continue-card {
        .font-light;
        height: 46px;
        background: rgba(91, 192, 215, 0.2);
        font-size: 16px;
        font-weight: 300;
        color: #5bc0d7;
        line-height: 46px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          cursor: pointer;
        }
        img {
          width: 12px;
          height: 12px;
          cursor: pointer;
        }
      }
    }
    .banner-img {
      margin: 20px 0;
      width: 600px;
      float: left;
      img {
        width: 100%;
      }
    }
  }
  .works-bg {
    background-image: url('~@/assets/imgs/home-world-bg.png');
  }
  .works {
    padding: 50px 0;
    .center-text {
      p {
        text-align: center;
      }
    }
    .works-list {
      padding-top: 32px;
      display: flex;
      justify-content: space-between;
    }
    .works-title {
      p {
        color: white;
      }
    }
  }
  .what {
    padding: 100px 0 74px;
    .title {
      .font-regular;
      font-size: 26px;
      font-weight: 400;
      color: @app-color;
      line-height: 32px;
    }
    .what-content {
      position: relative;
      .what-list {
        padding-right: 750px;
        padding-top: 30px;
        li {
          padding-left: 54px;
          position: relative;
          margin-top: 50px;
          &:before {
            content: ' ';
            display: inline-block;
            position: absolute;
            left: 0;
            top: 0px;
            background-image: url('../../assets/imgs/home-chencked.png');
            background-size: 100%;
            width: 26px;
            height: 26px;
          }
          .what-title {
            .font-regular;
            font-size: 20px;
            font-weight: 400;
            color: @app-black-color;
            line-height: 24px;
          }
          .what-desc {
            .font-light;
            padding-top: 6px;
            color: @app-body-color;
            font-size: 14px;
            font-weight: 300;
            line-height: 18px;
          }
        }
      }
      .img-box {
        position: absolute;
        right: 0;
        top: -20px;
        width: 600px;
        img {
          width: 100%;
        }
      }
    }
  }
  .delight {
    padding: 100px 0 46px 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    .delight-img-box {
      width: 700px;
    }
    .delight-right {
      display: flex;
      flex-direction: column;
      justify-items: center;
      padding-left: 90px;
      .delight-title {
        .font-regular;
        height: 32px;
        font-size: 26px;
        font-weight: 400;
        color: @app-color;
        line-height: 32px;
      }
      .delight-desc {
        .font-light;
        font-size: 14px;
        font-weight: 300;
        color: @app-body-color;
        padding-top: 5px;
        line-height: 20px;
      }
      .delight-right-content {
        .delight-right-list {
          padding-top: 30px;
          li {
            margin-top: 30px;
            .delight-right-title {
              .font-regular;
              font-size: 20px;
              font-weight: 400;
              color: @app-black-color;
              line-height: 24px;
            }
            .delight-right-desc {
              .font-light;
              padding-top: 6px;
              color: @app-body-color;
              font-size: 14px;
              font-weight: 300;
              line-height: 18px;
            }
          }
        }
      }
    }
  }
  .start {
    background-color: @app-color;
    height: 176px;
    .start-center {
      width: 1044px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      margin: 0px auto;
      .desc {
        .font-regular;
        width: 340px;
        height: 54px;
        font-size: 22px;
        font-weight: 400;
        color: #ffffff;
        line-height: 27px;
      }
      .img {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 349px;
        }
      }
      .btn {
        .font-light;
        width: 116px;
        height: 46px;
        background: #ffffff;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 300;
        color: @app-color;
        text-align: center;
        line-height: 46px;
      }
    }
  }
}
</style>
